// @ts-strict-ignore
import React, { useEffect, useState } from 'react'
import { query, brand, pathname } from '../../redux/app-selectors'

import sw from '../../utils/switch'
import loadable from '@loadable/component'
import { connect } from 'react-redux'
import {
  getSorts,
  getEligibilityExpired,
  getEligibilityProviderTimeout,
  getNoEligibilityResults,
} from '../../redux/product-tables/product-table-selectors'
import { getCreditCardEligibilityInformation } from '../../redux/product-tables/product-table-actions'
import { findEntityBySysId, getHitsWithExtraData } from '../../redux/contentful-selectors'
import { getProductTableRelations } from '../../utils/contentful'

import { setupTrackingCallbacksForTable } from '../../utils/segment-tracking'
import { getCalculatorId } from '../../utils/calculator-helpers'
import { getFiltersId } from '../../utils/filters-helpers'
import { getData } from '../../redux/elasticsearch/elasticsearch-actions'
import TopPicks from './top-picks'
import AboveTheFold from './above-the-fold'
import { FsCore } from '../../types/fs-core'
import { getESProductDataSetData } from '../../redux/elasticsearch/elasticsearch-selectors'
import MoneyVoiceTopPicks from './money-voice-top-picks'

const ProductTable = loadable(() => import('./product-table'))

const TableSelector = (props) => {
  const { brand, getCreditCardEligibilityInformation, query, settings } = props
  const emailResultsToken = query.emailToken
  const eligibility = !!props.variant.match('eligibility')
  const [isWireFrame, setIsWireFrame] = useState(eligibility)

  useEffect(() => {
    async function check() {
      const isRedirecting = await getCreditCardEligibilityInformation({
        datasetID: props.dataset.sys.id,
        productTableId: props.sys.id,
        brand,
        showZeroPercent: settings?.showZeroPercent ?? true,
        minEligibility: settings?.minEligibility ?? 0,
        maxEligibility: settings?.maxEligibility ?? 100,
        emailResultsToken,
      })
      if (!isRedirecting) {
        setIsWireFrame(false)
      }
    }

    if (eligibility) {
      check()
    }
  }, [
    brand,
    eligibility,
    getCreditCardEligibilityInformation,
    props.dataset.sys.id,
    props.sys.id,
    props.isExpired,
    settings?.showZeroPercent,
    settings?.minEligibility,
    settings?.maxEligibility,
  ])

  return sw({
    eligibilityresults: () => <ProductTable isWireFrameInitial={isWireFrame} {...props} />,
    toppicks: () => <TopPicks {...props} />,
    moneyvoicetoppick: () => <MoneyVoiceTopPicks {...props} />,
    abovethefold: () => <AboveTheFold {...props} />,
    abovethefoldhorizontal: () => <AboveTheFold {...props} horizontal={true} />,
    abovethefoldwithborder: () => <AboveTheFold {...props} border={true} />,
    default: () => <ProductTable {...props} />,
  })(props.variant.toLowerCase())
}

const ConnectTable = connect(
  (state: FsCore.State, props) => {
    const { variant, maxPerPage, linkOutCard } = props
    const schemaTracking = setupTrackingCallbacksForTable(state, props)

    const { productTableSchema, productDataset } = getProductTableRelations(state, {
      fields: props,
    })

    const hits = getHitsWithExtraData(state, productTableSchema.sys.id, productDataset.sys?.id)
    const sort = getSorts(state, productDataset.sys.id)
    const calculatorId = getCalculatorId(state, productTableSchema)
    const filtersId = getFiltersId(state, productTableSchema)
    const isExpired = getEligibilityExpired(state, productDataset.sys.id)
    const eligibilityProviderTimeout = getEligibilityProviderTimeout(state, productDataset.sys.id)
    const noEligibilityResults = getNoEligibilityResults(state, productDataset.sys.id)
    const fullProductData = getESProductDataSetData(state, props.dataset.sys.id)?.hits?.hits
    const linkOutCardEntity = linkOutCard && findEntityBySysId(state, linkOutCard.sys.id)

    return {
      ...productTableSchema.fields.schema,
      data: hits.length > 0 ? hits : productDataset?.fields?.data || [],
      schemaTracking,
      maxPerPage,
      variant,
      query: query(state),
      props,
      sort,
      calculatorId,
      filtersId,
      brand: brand(state),
      path: pathname(state),
      isExpired,
      eligibilityProviderTimeout,
      noEligibilityResults,
      datasetId: productDataset.sys.id,
      schemaId: productTableSchema.sys.id,
      tableId: props.sys.id,
      reviews: state.reviews,
      fullProductData,
      linkOutCard: linkOutCardEntity,
    }
  },
  { getData, getCreditCardEligibilityInformation },
)(TableSelector)

export default ConnectTable
